import { MessageCircle } from "lucide-react";
import { COMPANY } from "../lib/constants";

export default function WhatsAppFloat() {
  return (
    <a
      data-testid="whatsapp-float"
      href={COMPANY.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar no WhatsApp"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 md:w-16 md:h-16 bg-[#25D366] hover:bg-[#1da851] text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-110 transition-transform whatsapp-pulse"
    >
      <MessageCircle className="w-7 h-7 md:w-8 md:h-8" />
    </a>
  );
}
